import { PlaylistsRowDataProps } from '@modules/entertainment/models/playlists.model';
import { CallStateEnum } from '@shared/models/call-state.model';
import {
  CallStateMethodNames,
  CallStateMethods
} from '@shared/store-features/call-state-feature';

export interface PlaylistsActionParams {
  data?: PlaylistsRowDataProps;
  id?: any;
  state?: any;
  handleClose?: () => void;
}
export interface PlaylistsState extends CallStateMethods {
  callState: CallStateEnum;
  createRow: (params: PlaylistsActionParams) => Promise<any>;
  editRow: (params: PlaylistsActionParams) => void;
  deleteRow: (params: {
    id: string | string[];
    state: any;
    handleClose: () => void;
  }) => void;
}
interface PlaylistsStateMethods extends CallStateMethodNames {
  createRow: 'createRow';
  editRow: 'editRow';
  deleteRow: 'deleteRow';
}

export const PLAYLISTS_INITIAL_STATE: Omit<
  PlaylistsStateMethods,
  keyof PlaylistsState
> = {
  callState: CallStateEnum.Init
};
